(function(){
  var root=document.querySelector('.vbp'); if(!root) return;
  var track=root.querySelector('[data-track]'), slides=root.querySelectorAll('.vbp-slide'), thumbs=root.querySelectorAll('[data-thumb]'), counter=root.querySelector('[data-counter]');
  function idx(){ return Math.round(track.scrollLeft/(track.clientWidth||1)); }
  function go(i){ i=Math.max(0,Math.min(slides.length-1,i)); track.scrollTo({left:i*track.clientWidth,behavior:'smooth'}); }
  function sync(){
    var i=idx();
    thumbs.forEach(function(t,n){ t.classList.toggle('is-on',n===i); });
    if(counter) counter.textContent=(i+1)+' / '+slides.length;
    var on=thumbs[i]; if(on){ var p=on.parentNode; p.scrollTo({left:on.offsetLeft-p.clientWidth/2+on.clientWidth/2,behavior:'smooth'}); }
  }
  var st; track.addEventListener('scroll',function(){ clearTimeout(st); st=setTimeout(sync,70); });
  thumbs.forEach(function(b,n){ b.addEventListener('click',function(){ go(n); }); });
  var pv=root.querySelector('[data-prev]'), nx=root.querySelector('[data-next]');
  if(pv) pv.addEventListener('click',function(){ go(idx()-1); });
  if(nx) nx.addEventListener('click',function(){ go(idx()+1); });
  track.addEventListener('keydown',function(e){ if(e.key==='ArrowLeft') go(idx()-1); if(e.key==='ArrowRight') go(idx()+1); });

  var qty=root.querySelector('[data-qty]');
  root.querySelector('[data-minus]').addEventListener('click',function(){ qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1); });
  root.querySelector('[data-plus]').addEventListener('click',function(){ qty.value=(parseInt(qty.value,10)||1)+1; });

  var variants=[]; try{ variants=JSON.parse(root.querySelector('[data-variants]').textContent); }catch(e){}
  var fmt=new Intl.NumberFormat(undefined,{style:'currency',currency:root.getAttribute('data-currency')||'USD'});
  var idEl=root.querySelector('[data-id]'), priceEl=root.querySelector('[data-price]'), cmpEl=root.querySelector('[data-compare]'), saveEl=root.querySelector('[data-save]');
  var stock=root.querySelector('[data-stock]'), atc=root.querySelector('[data-atc]'), pay=root.querySelector('[data-pay]');
  var bar=root.querySelector('[data-bar]'), barBtn=root.querySelector('[data-bar-btn]'), barPrice=root.querySelector('[data-bar-price]'), skuEl=root.querySelector('[data-sku]');
  function pick(){
    var chosen=[]; root.querySelectorAll('[data-opt]:checked').forEach(function(r){ chosen[parseInt(r.getAttribute('data-pos'),10)-1]=r.value; });
    return variants.filter(function(v){ return v.options.every(function(o,i){ return o===chosen[i]; }); })[0];
  }
  function apply(v){
    if(!v) return;
    idEl.value=v.id; priceEl.textContent=fmt.format(v.price/100); barPrice.textContent=fmt.format(v.price/100);
    var sale=v.compare_at_price&&v.compare_at_price>v.price;
    cmpEl.hidden=!sale; saveEl.hidden=!sale;
    if(sale){ cmpEl.textContent=fmt.format(v.compare_at_price/100); saveEl.textContent='Save '+Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'%'; }
    if(skuEl&&v.sku) skuEl.textContent=v.sku;
    stock.classList.toggle('is-out',!v.available);
    stock.querySelector('span').textContent=v.available?'In stock. Ships from our US warehouse':'Sold out';
    [atc,barBtn].forEach(function(b){ b.disabled=!v.available; b.textContent=v.available?'Add to cart':'Sold out'; });
    if(pay) pay.hidden=!v.available;
    if(v.featured_media){ for(var n=0;n<slides.length;n++){ if(slides[n].getAttribute('data-media-id')==String(v.featured_media.id)){ go(n); break; } } }
    if(history.replaceState) history.replaceState(null,'','?variant='+v.id);
  }
  root.querySelectorAll('[data-opt]').forEach(function(r){ r.addEventListener('change',function(){ apply(pick()); }); });

  var form=root.querySelector('form.vbp-form');
  if('IntersectionObserver' in window && atc){
    new IntersectionObserver(function(e){ bar.classList.toggle('is-on',!e[0].isIntersecting && e[0].boundingClientRect.top<0); }).observe(atc);
  }
  barBtn.addEventListener('click',function(){ if(form.requestSubmit) form.requestSubmit(); else form.submit(); });
})();